import {Button} from '@common-web/components/ui/button';
import {useRfcContext} from '../../RfcContext';

export function CopyFromSection125(props: {onCopy: () => void; title?: string}) {
  const {section125FormEnabled} = useRfcContext();
  if (!section125FormEnabled) return null;

  return (
    <div className='flex flex-col items-center gap-4 p-3 mb-4 bg-blue-50 border border-blue-200 rounded-sm'>
      <div className='text-sm text-brand-navy'>
        Copy values from your 125 Program form into this section.
      </div>
      <Button type='button' size='sm' variant='default' onClick={props.onCopy}>
        Copy form entries
      </Button>
    </div>
  );
}
